// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"363":"2235cfb5e24e88b410f9","695":"241a89f5a4259fec32c2"}[chunkId] + ".js";
};